<template>
  <component :is="computedComponent"></component>
</template>

<script>

import Thanks from '@/views/Thanks'
import ThanksEn from '@/views/Thanks_en'
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  components: {
    Thanks,
    ThanksEn
  },
  computed: {
    ...mapGetters([
      'language'
    ]),
    computedComponent () {
      if (this.language === 'de') {
        return 'Thanks'
      } else {
        return 'ThanksEn'
      }
    }
  }
}
</script>
